module.exports = __webpack_public_path__ + "assets/avainlippu.1d87e98d98563255c988020a408f7c37.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avainlippu.png
// module id = 114
// module chunks = 0